import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal, MODAL_TYPES } from 'actions/modals';
import AlertModal from 'components/modals/alertModal';
import ConfirmModal from 'components/modals/confirmModal';
import CustomModal from 'components/modals/customModal';

class ModalOutlet extends Component {
  closeModal(modal) {
    this.props.closeModal(modal.props.key);
  }

  render() {
    return (
      <div>
        {this.props.modals.map(modal => {
          switch (modal.props.modalType) {
            case MODAL_TYPES.alert:
              return (
                <AlertModal
                  {...modal.props}
                  closeModal={() => this.closeModal(modal)}
                />
              );
            case MODAL_TYPES.confirm:
              return (
                <ConfirmModal
                  {...modal.props}
                  closeModal={() => this.closeModal(modal)}
                />
              );
            case MODAL_TYPES.custom:
              return (
                <CustomModal
                  {...modal.props}
                  closeModal={() => this.closeModal(modal)}
                />
              );
            case MODAL_TYPES.error:
              return (
                <AlertModal
                  {...modal.props}
                  closeModal={() => this.closeModal(modal)}
                />
              );
            default:
              return <div />;
          }
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { modals: state.modals.all };
}

export default connect(mapStateToProps, { closeModal })(ModalOutlet);



// WEBPACK FOOTER //
// ./src/components/modals/modalOutlet/index.js